<template>
    <div class="covid">
        <Head />
        <div class="banner">
            <div class="box">
                <div class="left">
                    <img v-if="$i18n.locale == 'fr'" src="../../assets/covid/logo_fr.png" alt="" style="width: 400px">
                    <img v-else-if="$i18n.locale == 'ru'" src="../../assets/covid/logo_ru.png" alt="" style="width: 400px">
                    <img v-else src="../../assets/covid/logo.png" alt="">
                </div>
                <div class="right">
                    <div class="title">{{$t('covid.col1.i1')}}</div>
                    <p>{{$t('covid.col1.i2')}}</p>
                </div>
            </div>
        </div>
        <div class="video-info">
            <div class="box node-anchor">
                <div class="left">
                    <video-player 
                        class="video-player-box"
                        ref="videoPlayer"
                        :options="playerOptions"
                        :playsinline="true"
                    >
                    </video-player>
                    <p>{{$t('covid.col1.i3')}}</p>
                </div>
                <div class="right">
                    <p>{{$t('covid.col1.i4')}}</p>
                    <p>{{$t('covid.col1.i5')}}</p>
                </div>
            </div>
        </div>
        <div class="desc">
            <div class="box">
                <div class="left">
                    <h3 style="margin-right: -30px">{{$t('covid.col2.i1')}}</h3>
                    <p class="tips">{{$t('covid.col2.i2')}}</p>
                    <p class="info">{{$t('covid.col2.i3')}}</p>
                    <ul>
                        <li>{{$t('covid.col2.i4')}}</li>
                        <li>{{$t('covid.col2.i5')}}</li>
                        <li>{{$t('covid.col2.i6')}}</li>
                    </ul>
                </div>
                <div class="right">
                    <div>
                        <img src="../../assets/covid/pic1.png" alt="">
                    </div>
                    <div style="margin-top: 40px;">
                        <img src="../../assets/covid/pic2.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div class="product-info">
            <div class="box">
                <h3>{{$t('covid.col3.i1')}}</h3>
                <p>{{$t('covid.col3.i2')}}</p>
                <div class="request">
                    <span @click="showPopup = true" style="cursor: pointer; display: inline-block" class="learn-more-hover">
                        <span class="more-img-outer"></span>
                        <span class="more-right-word">{{$t('covid.col3.i3')}}</span>
                    </span>
                </div>
                <ul>
                    <li>
                        <img src="../../assets/icon/logo1.png" alt="">
                        <div class="info">
                            <p>{{$t('covid.col3.i4')}}</p>
                            <p>{{$t('covid.col3.i5')}}</p>
                            <p>{{$t('covid.col3.i6')}}</p>
                        </div>
                        <p class="box-desc">{{$t('covid.col3.i7')}}</p>
                        <div class="go">
                            <a href="/welmshome" ><span>{{$t('covid.col3.i8')}}</span><img src="../../assets/icon/arrow.png" alt=""><img class="arrow_hover" src="../../assets/icon/arrow_hover.png" alt=""></a>
                        </div>
                    </li>
                    <li>
                        <img src="../../assets/icon/logo2.png" alt="">
                        <div class="info">
                            <p>{{$t('covid.col3.i9')}}</p>
                            <p>{{$t('covid.col3.i10')}}</p>
                            <p>{{$t('covid.col3.i11')}}</p>
                        </div>
                        <p class="box-desc">{{$t('covid.col3.i12')}}</p>
                        <div class="go">
                            <a href="https://www.mindonsite.com/en/" target="_blank"><span>{{$t('covid.col3.i13')}}</span><img src="../../assets/icon/arrow.png" alt=""><img class="arrow_hover" src="../../assets/icon/arrow_hover.png" alt=""></a>
                        </div>
                    </li>
                    <li>
                        <img src="../../assets/icon/logo3.png" alt="">
                        <div class="info">
                            <p class="hide">{{$t('covid.col3.i14')}}</p>
                            <p>{{$t('covid.col3.i15')}}</p>
                            <p>{{$t('covid.col3.i16')}}</p>
                        </div>
                        <p class="box-desc">{{$t('covid.col3.i17')}}</p>
                        <div class="go">
                            <a href="//global.wdyedu.com/" target="_blank"><span>{{$t('covid.col3.i18')}}</span><img src="../../assets/icon/arrow.png" alt=""><img class="arrow_hover" src="../../assets/icon/arrow_hover.png" alt=""></a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <popup :show.sync="showPopup"></popup>
        <Footer />
    </div>
</template>
<script>
import Head from '../../components/head';
import Footer from '../../components/footer';
import Popup from '../../components/popup';
export default {
    components: {
        Head,
        Footer,
        Popup,
    },
    data() {
        return {
            playerOptions: {
                preload: 'auto',
                width: '534px',
                height: '300px',
                poster: require('../../assets/covid/video.png'),
                sources: [{
                    type: "video/mp4",
                    src: 'https://welms.oss-cn-beijing.aliyuncs.com/overseas/Join%20the%20COVID-19%20Education%20Coalition%281%29.mp4',
                }]
            },
            showPopup: false,
        }
    },
    methods: {
    }
}
</script>
<style lang="less">
.covid {
    height: 100%;
    .banner {
        font-size: 0;
        background:url('../../assets/covid/bg1.jpg') no-repeat;
        background-position: center;
        background-size: cover;
        height: 700px;
        display: flex;
        align-items: center;
        .box {
            margin: 0 auto;
            width: 1200px;
            height: 231px;
            display: flex;
            align-items: center;
            .right {
                flex: 1;
                margin-left: 60px;
                .title {
                    line-height: 1.5;
                    color: #ffffff;
                    font-size: 24px;
                }
                p {
                    margin-top: 20px;
                    color: #ffffff;
                    font-family: HelveticaNeue, Arial;
                    font-size: 16px;
                    line-height: 1.5;
                }
            }
        }
    }
    .video-info {
        width: 100%;
        height: 410px;
        background: linear-gradient(360deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.1) 100%);
        .box {
            box-sizing: border-box;
            padding: 20px 40px 20px 20px;
            margin: 0 auto;
            width: 1200px;
            position: relative;
            top: -35px;
            height: 400px;
            background: rgba(255, 255, 255, 1);
            display: flex;
            box-shadow: 0 6px 30px rgba(0, 0, 0, 0.08);
            .right {
                padding-top: 20px;
                font-size: 20px;
                margin-left: 30px;
                font-family: HelveticaNeue, Arial;
                p {
                    line-height: 1.75;
                }
                p~p {
                    margin-top: 40px;
                }
            }

            .left {
                p {
                    margin-top: 10px;
                    color: #A34900;
                    font-size: 16px;
                }
            }
        }
        .video-player-box {
            .vjs-loading-spinner + .vjs-big-play-button {
                background: url('../../assets/icon/play_icon.png');
                width: 70px;
                height: 70px;
                border: none;
                background-size: 100% 100%;
                left: 50%;
                top: 50%;
                transform: translateX(-50%) translateY(-50%);
                span {
                    display: none;
                }
            }
            .vjs-loading-spinner + .vjs-icon-placeholder {
                display: none;
            }
        }
    }
    .desc {
        background: #ffffff;
        width: 100%;
        overflow: hidden;
        .box {
            width: 1200px;
            position: relative;
            margin: 0 auto;
            display: flex;
            padding: 50px 0 65px 0;
            // &::after {
            //     content: '';
            //     position: absolute;
            //     top: 0;
            //     right: -50px;
            //     width: 700px;
            //     height: 700px;
            //     border: 4px solid rgba(245, 159, 68, 0.2);
            //     border-radius: 50%;
            // }
            h3 {
                font-size: 48px;

            }
            .left {
                font-family: HelveticaNeue, Arial;
                width: 740px;
                .tips {
                    margin-top: 46px;
                    padding: 18px 20px;
                    font-size: 18px;
                    line-height: 1.5;
                    background: rgba(245, 159, 68, 0.15);
                    color: #FD8E0D;
                }
                .info {
                    margin-top: 26px;
                    font-size: 16px;
                    line-height: 30px;
                }
                ul {
                    margin-top: 28px;
                    font-size: 16px;
                    color: #666666;
                    line-height: 30px;
                    li {
                        padding-left: 22px;
                        position: relative;
                        &::before {
                            position: absolute;
                            content: '';
                            width: 10px;
                            height: 10px;
                            background: #FD8E0D;
                            left: 0;
                            top: 9px;
                        }
                    }
                    li~li {
                        margin-top: 28px;
                    }
                }
            }
            .right {
                position: relative;
                padding: 67px 0 47px 35px;
                margin-left: 60px;
                font-size: 0;
                z-index: 4;
                &::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 700px;
                    height: 700px;
                    border: 4px solid rgba(245, 159, 68, 0.2);
                    border-radius: 50%;
                }
                img {
                    width: 400px;
                }
                div {
                    position: relative;
                    z-index: 3;
                }
            }
        }
    }

    .product-info {
        background: #2834AA;
        padding: 80px 0 100px;
        color: #ffffff;
        .box {
            width: 1200px;
            margin: 0 auto;
            h3 {
                font-size: 48px;
            }
            p {
                margin-top: 50px;
                font-size: 16px;
                font-family: HelveticaNeue, Arial;
                line-height: 30px;
            }
            .request {
                margin-top: 43px;
                font-size: 20px;
                img {
                    margin-right: 16px;
                    width: 70px;
                    height: 70px;
                    vertical-align: middle;
                }
            }
            ul {
                margin-top: 55px;
                display: flex;
                li {
                    position: relative;
                    box-sizing: border-box;
                    padding: 60px 30px 0;
                    flex: 1;
                    height: 609px;
                    background: #ffffff;
                    img {
                        width: 100%;
                    }
                    .info {
                        margin-top: 24px;
                        color: #333333;
                        font-size: 20px;
                        p {
                            font-family: HelveticaNeue, Arial;
                            font-weight: bold;
                            margin-top: 0;
                            line-height: 1.5;  
                        }
                    }
                    .box-desc {
                        margin-top: 24px;
                        font-size: 14px;
                        color: #666666;
                        line-height: 24px;
                    }
                    .hide {
                        visibility: hidden;
                    }
                    .go {
                        width: 100%;
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        height: 60px;
                        background: rgba(245, 159, 68, 0.15);
                        line-height: 60px;
                        text-align: center;
                        &:hover {
                            cursor: pointer;
                            background: #F99E3E;
                            a {
                                color: #ffffff;
                            }
                            img {
                                display: none;
                            }
                            .arrow_hover {
                                display: inline-block;
                            }
                        }
                        a {
                            text-decoration: none;
                            color: #FD8E0D;
                            font-size: 16px;
                        }
                        span {
                            vertical-align: middle;
                            margin-right: 8px;
                        }
                        img {
                            height: 14px;
                            width: 15px;
                            vertical-align: middle;
                        }
                        .arrow_hover {
                            display: none;
                        }
                    }
                }
                li~li {
                    margin-left: 40px;
                }
            }
        }
    }
}
.lang-ru {
    .covid .video-info .box .right {
        padding-top: 0px;
    }
    .covid .video-info .box .right p ~ p {
        margin-top: 20px;
    }
}
.lang-fr {
    .covid .video-info .box .right {
        padding-top: 0px;
    }
    .covid .video-info .box .right p ~ p {
        margin-top: 20px;
    }
}
</style>